export default "/images/generate-with-ai.png?a34e96ceb6a5bfe8c082ef0f9624d0b9";